import { useApolloClient } from '@apollo/client'
import { DataTableSource } from 'generated/resources/datatable.graphql'
import { FinanceInvoiceResourceInput } from 'generated/resources/graphql'

import DataTable from 'modules/core/components/DataTable'

import { InvoicesDropzone } from 'modules/finance/components/InvoicesDropzone'

export interface ResourceInvoicesProps<T> {
  source: DataTableSource<T, string>
  resource: FinanceInvoiceResourceInput
  emptyState?: React.ReactNode
  vendorId?: string
}

const ResourceInvoices = <T, S>({
  source,
  resource,
  emptyState,
  vendorId,
}: ResourceInvoicesProps<T>) => {
  const apolloClient = useApolloClient()

  return (
    <>
      <InvoicesDropzone
        onUploadFinish={() => {
          apolloClient.refetchQueries({
            include: [source.query],
          })
        }}
        resources={[resource]}
        vendorId={vendorId}
      />

      <DataTable
        disableDefaultActions
        autoWidth
        persistFilters={false}
        source={source}
        sort={{
          path: 'financialDocument_id',
          direction: 'asc',
        }}
        pagination={{
          kind: 'offset',
          itemsPerPage: 25,
        }}
        emptyState={emptyState}
      />
    </>
  )
}

export default ResourceInvoices
